module.exports = __webpack_public_path__ + "media/lucario.5f692cc7.wav";